// 反差吃瓜 - 内容数据（虚构当事人与事件，用于静态展示与演示）

export const SITE_NAME = "反差吃瓜局";
export const SITE_SLOGAN = "人设面前，别急着下结论。";

export interface TimelinePoint {
  time: string;
  title: string;
  text: string;
}

export interface Facet {
  label: string;
  text: string;
  points: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface CaseItem {
  id: string;
  person: string;
  title: string;
  category: string;
  tag: string;
  summary: string;
  cover: string;
  hot: number;
  heatText: string;
  views: string;
  comments: string;
  published: string;
  watch: string[];
  before: Facet;
  after: Facet;
  timeline: TimelinePoint[];
  faq: FaqItem[];
  paragraphs: string[];
}

export const CATEGORIES = [
  { key: "all", label: "全部反转" },
  { key: "persona", label: "人设反转" },
  { key: "identity", label: "身份揭秘" },
  { key: "glamour", label: "滤镜照妖镜" },
  { key: "hypocrisy", label: "言行双标" },
  { key: "slap", label: "打脸实录" },
];

export const cases: CaseItem[] = [
  {
    id: "case-1",
    person: "暖姐·林若薇",
    title: "情感导师「暖姐」人设崩塌：白天煲鸡汤，夜里收智商税",
    category: "persona",
    tag: "人设反转",
    summary:
      "坐拥数百万粉丝的知心姐姐「暖姐」，靠一句句温柔鸡汤出圈，却在被接连扒出销售话术、天价课程与割裂发言后跌落神坛。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20two%20contrasting%20faces%20split%20in%20half%20one%20gentle%20smiling%20warm%20the%20other%20cold%20calculating%20in%20warm%20paper%20tones%20with%20vermilion%20red%20and%20amber%20accents%2C%20graphic%20high%20contrast%2C%20minimalist%2C%20high%20detail&width=1200&height=900&seq=fc-case-01&orientation=landscape",
    hot: 98,
    heatText: "本周热度第一",
    views: "682万",
    comments: "3.4万",
    published: "2026-08-28",
    watch: ["#情感导师翻车", "#人设反转", "#直播带货"],
    before: {
      label: "公开人设",
      text: "镜头前的「暖姐」，是无数深夜emo网友的精神支柱。",
      points: [
        "标签：治愈系知心姐姐、两性关系导师",
        "口头禅：「先爱自己，再爱别人」",
        "直播间经常含泪分享原生家庭故事",
      ],
    },
    after: {
      label: "反转实锤",
      text: "录音与聊天记录流出后，粉丝才发现「鸡汤」只是包装纸。",
      points: [
        "被曝一套「挽回课」卖到9999元，话术几乎照搬",
        "私下吐槽付费学员「人傻钱多」的录音曝光",
        "一边劝粉丝别恋爱脑，一边被拍到密集出入奢侈品店",
      ],
    },
    timeline: [
      { time: "2024-03", title: "一夜爆红", text: "凭借「分手后如何自洽」系列短视频走红，一周涨粉百万，被冠以「国民知心姐姐」称号。" },
      { time: "2025-11", title: "质疑初现", text: "有学员在匿名社区发帖，称花了近万元买的课程只是旧视频打包，随即引发第一轮退款潮。" },
      { time: "2026-05", title: "录音实锤", text: "一段疑似其本人的语音流出，内容与公开人设严重割裂，登上热搜词条第一名。" },
      { time: "2026-08", title: "集体翻车", text: "多家媒体跟进报道，商务合作陆续终止，账号评论区被「还钱」刷屏，人设正式崩塌。" },
    ],
    faq: [
      { q: "「暖姐」事件的核心争议点是什么？", a: "核心在于公开贩卖的「温暖与真诚」与私下言行严重割裂。粉丝付费购买的既是课程，也是对她人设的信任，当两者同时落空，反噬自然发生。" },
      { q: "为什么靠人设起家的人更容易翻车？", a: "人设本质是过度理想化的公开形象，越是包装完美，越容易在细节处失真。一旦真实行为与设定差距过大，观众的反差感就越强烈，翻车也就越彻底。" },
      { q: "这件事给了内容创作者什么提醒？", a: "内容可以理想化，但底线是不能欺骗。贩卖情绪与贩卖承诺之间只有一线之隔，真诚与可持续的内容远比完美人设走得更远。" },
    ],
    paragraphs: [
      "在「反差吃瓜局」，我们关注的从来不只是一个人的翻车，而是那个「从神坛坠落的瞬间」。暖姐林若薇的故事，恰恰是观察人设经济最好的样本。",
      "回看她的走红路径，几乎每一步都精准踩在流量密码上：原生家庭创伤、深夜情感需求、女性自我成长。她用温柔的声线，把复杂的情感问题拆解成一句句可以被截图收藏的「金句」，评论区清一色的「谢谢暖姐，看哭了」。",
      "然而当她的商业版图被完整拼出，人们才发现，镜头前的知心姐姐与幕后的操盘手，几乎判若两人。天价课程背后是高度同质化的模板话术，而对付费学员的真实态度，也被录音一锤定音。",
      "反差并不稀奇，稀奇的是她把反差包装得如此滴水不漏。这也让无数曾经视她为「精神支柱」的网友，在真相面前感到被背叛的愤怒。",
      "从行业角度看，暖姐事件更像是一面镜子：当「信任」成为可以明码标价的商品，透支它的速度，往往比建立它要快得多。人设会崩塌，但人们对真诚的渴望不会，这或许是这件事最值得回味的注脚。",
    ],
  },
  {
    id: "case-2",
    person: "自律帝·陈一川",
    title: "「自律帝」人设崩塌现场：白天撸铁晒腹肌，深夜烧烤配茅台",
    category: "glamour",
    tag: "前后对比",
    summary:
      "以「365天不断更」自律人设走红的健身博主，被拍到深夜撸串喝大酒，评论区瞬间炸锅。滤镜到底骗了多少人？",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20collage%20of%20fitness%20athlete%20silhouette%20versus%20midnight%20street%20bbq%20scene%20in%20warm%20contrast%20tones%20vermillion%20and%20amber%20on%20cream%20paper%2C%20two%20worlds%20split%20composition%2C%20graphic%20minimalist%2C%20high%20detail&width=1200&height=900&seq=fc-case-02&orientation=landscape",
    hot: 94,
    heatText: "话题讨论量暴涨",
    views: "521万",
    comments: "2.1万",
    published: "2026-08-30",
    watch: ["#自律帝塌房", "#健身网红", "#滤镜打假"],
    before: {
      label: "公开人设",
      text: "「自律帝」陈一川，号称全年无休、滴水不漏的健身机器。",
      points: [
        "标签：365天不断更、魔鬼自律、六块腹肌",
        "每天6点准时直播晨跑，雷打不动",
        "号称「十年没碰过一滴酒」",
      ],
    },
    after: {
      label: "反转实锤",
      text: "一次深夜被偶遇，彻底击碎了「铁人」滤镜。",
      points: [
        "深夜被路人拍到与朋友路边撸串、小酌",
        "自拍用的精修图与生图差距巨大，身材管理全靠滤镜",
        "被扒出「晨跑直播」实为提前录制的循环素材",
      ],
    },
    timeline: [
      { time: "2023-06", title: "自律人设出圈", text: "「365天晨跑挑战」系列让他迅速积累第一批死忠粉，被称为健身圈自律天花板。" },
      { time: "2025-12", title: "生图外流", text: "健身房的素人照片被传到论坛，网友发现其真实体脂与展示身材差距明显。" },
      { time: "2026-07", title: "深夜偶遇", text: "路人深夜偶遇其路边撸串喝酒并拍下视频，引发「自律假象」大讨论。" },
      { time: "2026-08", title: "人设坍塌", text: "面对发酵舆论，其团队承认部分素材存在「美化与剪辑」，评论区彻底沦陷。" },
    ],
    faq: [
      { q: "健身博主晒身材也成了一种「照骗」吗？", a: "是的。修图、打光、找角度、用特定状态拍摄，会让身材呈现远优于日常。自律人设叠加滤镜美化，双重包装最容易放大反差。" },
      { q: "为什么网友对「自律人设」格外敏感？", a: "自律被包装成一种道德优越感，观众代入后会产生「我也可以」的投射。一旦发现是演的，被欺骗感会直接转化为愤怒与围剿。" },
      { q: "普通人该如何看待网上的自律内容？", a: "把博主当「内容创作者」而非「人生模板」。真正可持续的自律是反人性的、枯燥的，那些每天标榜「完美执行」的内容，反而更值得怀疑。" },
    ],
    paragraphs: [
      "自律帝陈一川的翻车，几乎是近年来「滤镜经济」的又一次集体照妖。人们愤怒的，不只是他的身材可能注了水，更是那句被反复消费的「自律给我自由」背后，居然是一场精心编排的真人秀。",
      "他深谙「反差」传播的魔力：越是把「极致自律」这种人设标签贴在身上，越能激发观众「我不如他」的焦虑，进而转化为持续的关注与付费。只是这套玩法，最怕的就是镜头之外的意外走光。",
      "深夜撸串本无可厚非，真正刺破幻想的，是「十年不沾一滴酒」的豪言被现实精准打脸。人设越是完美到近乎失真，现实里任何一个普通人的举动，都足以让它瞬间倾覆。",
      "讽刺的是，打脸之后，他那条「早睡早起身体好」的置顶视频至今没有删除，评论区却早已从膜拜变成了大型考古现场。",
      "在我们看来，这场反转的本质，是「真实」与「表演」在流量场里的正面冲突。它提醒每一位观众：别把人设当人品，也提醒每一位创作者：滤镜可以修饰外表，却修饰不了持续暴露的言行。",
    ],
  },
  {
    id: "case-3",
    person: "素人学霸·苏予",
    title: "神秘「素人学霸」身份揭秘：人设是剧本，学历是包装",
    category: "identity",
    tag: "身份揭秘",
    summary:
      "自称出身贫寒、逆袭顶尖学府的「素人学霸」，被扒出家庭背景与学历履历大面积存疑。标签背后的身份，究竟是谁在扮演？",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20editorial%20art%20of%20a%20young%20student%20identity%20made%20of%20puzzle%20pieces%20with%20fake%20diploma%20seal%20in%20warm%20paper%20and%20amber%20tone%2C%20mystery%20and%20unmask%20theme%2C%20graphic%20high%20contrast%2C%20high%20detail&width=1200&height=900&seq=fc-case-03&orientation=landscape",
    hot: 89,
    heatText: "搜索量持续攀升",
    views: "437万",
    comments: "1.8万",
    published: "2026-09-01",
    watch: ["#学霸造假", "#人设包装", "#身份疑云"],
    before: {
      label: "公开人设",
      text: "「从流水线到象牙塔」的励志叙事，感动了无数打工少年。",
      points: [
        "标签：寒门贵子、逆袭学霸、纯素人",
        "讲述自己从电子厂一路考进名校的奋斗史",
        "主张「只要努力，人人都能翻身」",
      ],
    },
    after: {
      label: "反转实锤",
      text: "履历与背景被逐条起底，励志故事开始出现裂缝。",
      points: [
        "被扒出其家庭并非所谓「贫寒」，父母为地方公职人员",
        "所谓「名校学历」实为合作机构结业证而非全日制学位",
        "「工厂打工」经历被质疑为剧本设定的拍摄桥段",
      ],
    },
    timeline: [
      { time: "2023-10", title: "励志人设上线", text: "一段「从流水线逆袭名校」的自述视频走红，人设主打「素人 + 奋斗」双标签。" },
      { time: "2025-06", title: "首轮起底", text: "网友开始比对公开信息，对其「工厂打工」时间线与求学经历提出质疑。" },
      { time: "2026-04", title: "学历风波", text: "所谓名校学历被扒出为结业项目，与全日制学历存在本质差别，争议全面升级。" },
      { time: "2026-09", title: "承认有团队", text: "运营团队发声明称早期视频存在「艺术加工」，素人励志叙事迎来反转。" },
    ],
    faq: [
      { q: "「寒门逆袭」人设为什么格外能博取信任？", a: "因为它同时击中了普通人的奋斗共鸣与「出身决定不了命运」的希望感。越是底层叙事，观众越愿意共情，越少设防。" },
      { q: "这起事件里真正的反差点在哪里？", a: "反差不在「有没有努力」，而在「贩卖的苦难与经历是否真实」。当励志成为产业链，每一个精心设计的标签，都是对真实奋斗者的透支。" },
      { q: "观众该如何识别「剧本式」人设？", a: "少看叙事、多看细节。真实经历经得起交叉验证，而剧本往往在时间线、第三方佐证等硬信息上经不起推敲。" },
    ],
    paragraphs: [
      "在无数个深夜被转发的励志故事里，「素人学霸」苏予是特别能打动人的那一个。电子厂、流水线、深夜背书、一举逆袭……这套叙事几乎写进了所有普通人的爽点里。",
      "然而当网友开始逐条比对时间线与公开信息时，故事的裂缝逐渐显现。家庭背景、求学经历、工作履历，每一条看似「真实的细节」，都在第三方资料面前变得脆弱。",
      "人们愤怒的，或许不只是身份被包装，更是那种「我差一点就信了」的被愚弄感。励志内容之所以动人，正因为它的底色是真实；一旦确认是剧本，感动就变成了大型讽刺。",
      "行业里常说「真诚是最大的流量」，而这场反转恰恰说明：当真诚本身被包装成商品标签，它就不再是真诚，而是另一种更高明的表演。",
      "这也是反差吃瓜局持续追踪身份揭秘类题材的原因——我们想看见的，不是某个人狼狈收场，而是流量逻辑如何一次次教人伪装，又如何一次次被真相反杀。",
    ],
  },
  {
    id: "case-4",
    person: "环保大使·周之远",
    title: "「环保大使」言行双标：一边喊低碳，一边坐着私人飞机开豪车",
    category: "hypocrisy",
    tag: "言行双标",
    summary:
      "顶着环保公益人设走红的周之远，日常输出低碳生活理念，却在私人飞机与多辆豪车面前，把「双标」二字写在了脸上。",
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20editorial%20art%20of%20globe%20and%20green%20leaf%20versus%20private%20jet%20silhouette%20in%20warm%20vermilion%20amber%20and%20cream%20paper%20tone%2C%20hypocrisy%20double%20standard%20theme%2C%20minimalist%20graphic%20contrast%2C%20high%20detail&width=1200&height=900&seq=fc-case-04&orientation=landscape",
    hot: 91,
    heatText: "公益圈关注度高",
    views: "489万",
    comments: "2.6万",
    published: "2026-09-03",
    watch: ["#环保双标", "#人设争议", "#公益圈"],
    before: {
      label: "公开人设",
      text: "周之远是镜头前的「低碳生活布道者」。",
      points: [
        "标签：环保公益人、零浪费生活方式",
        "常在视频里号召大家少开车、多骑行",
        "自称坚持自带餐具、分类回收多年",
      ],
    },
    after: {
      label: "反转实锤",
      text: "一段停机坪画面，让人设与环境理念正面冲突。",
      points: [
        "被拍到频繁乘坐私人飞机出行，能耗争议巨大",
        "名下登记有多辆大排量豪车，与低碳主张严重矛盾",
        "面对质疑一度沉默，后改口称「商务需要」",
      ],
    },
    timeline: [
      { time: "2022-09", title: "环保人设起势", text: "凭借一系列浅显易懂的低碳科普走红，受邀参加多场公益演讲。" },
      { time: "2025-08", title: "豪车起底", text: "有网友发现其名下登记多辆大排量汽车，与主张相悖，引发第一波「双标」讨论。" },
      { time: "2026-06", title: "私人飞机曝光", text: "停机坪画面流出，低碳布道者的高碳出行引发全网群嘲。" },
      { time: "2026-09", title: "代言危机", text: "多家环保相关品牌暂停合作，其公益背书公信力受到重创。" },
    ],
    faq: [
      { q: "言行双标为什么比纯造假更让网友反感？", a: "因为双标意味着「知而故犯」。当事人清楚什么是对的、什么是错的，却选择把标准留给别人、把例外留给自己，这种优越感极易激起反弹。" },
      { q: "做公益的人就一定要过苦行僧生活吗？", a: "并不要求人人苦行，但主张的号召与自身行为不应存在系统性矛盾。公众反感的从来不是个体选择，而是拿着环保旗帜谋取名声却回避责任。" },
      { q: "这件事折射出什么问题？", a: "它反映「环保」等价值标签正被当作身份装饰品。真正的影响力，应当建立在言行一致之上，而非一句句漂亮的公开表态。" },
    ],
    paragraphs: [
      "「言行双标」大概是所有反差类型里最不需要证据就能让人火冒三丈的一种。周之远的故事，把这种「自己做不到，却教别人做」的荒诞演绎到了极致。",
      "他拥有一个近乎完美的环保叙事：低碳、零浪费、自带餐具、倡导骑行。在镜头前，他语气诚恳，仿佛每一句号召都出自骨子里的信念。",
      "可当停机坪的画面与名下的豪车登记一一浮出水面，人们发现，那个天天喊「少开一天车」的人，自己的生活却与低碳毫不沾边。公共号召与私人生活之间的巨大落差，让他过去所有的苦口婆心都显得格外刺眼。",
      "面对汹涌的质疑，他没有第一时间回应碳排放的实质问题，反而用「商务需要」这类说辞搪塞，进一步放大了公众的愤怒。",
      "反差吃瓜局想借此讨论的，是一种更普遍的现象：当道德与公益成为人设的外衣，它们就不再是责任，而沦为一种精致的表演。而观众最无法接受的，永远是那个「说一套、做一套」的人，站上道德高地指手画脚。",
    ],
  },
  {
    id: "case-5",
    person: "清纯甜心·桑晚",
    title: "「清纯甜心」滤镜碎裂：纯欲顶流被扒早年物料，前后反差惊呆网友",
    category: "glamour",
    tag: "滤镜照妖镜",
    summary:
      "靠清纯甜美元气感出圈的桑晚，被考古出大量风格迥异的早年物料。同一张脸，两种人设，观众直呼「不敢认」。",
    cover:
      "https://readdy.ai/api/search-image?query=fashion%20editorial%20illustration%20of%20two%20versions%20of%20the%20same%20young%20woman%20one%20sweet%20innocent%20pastel%20the%20other%20bold%20edgy%20in%20warm%20amber%20vermilion%20and%20cream%20tones%2C%20before%20after%20makeover%20contrast%2C%20minimalist%20high%20detail&width=1200&height=900&seq=fc-case-05&orientation=landscape",
    hot: 96,
    heatText: "全平台刷屏",
    views: "756万",
    comments: "4.2万",
    published: "2026-09-05",
    watch: ["#纯欲顶流", "#黑历史考古", "#滤镜前后"],
    before: {
      label: "公开人设",
      text: "桑晚是无数宅男的「初恋白月光」。",
      points: [
        "标签：清纯、甜妹、元气少女",
        "常以邻家女孩形象出现，说话轻声细语",
        "自称「社恐、单纯、没谈过恋爱」",
      ],
    },
    after: {
      label: "反转实锤",
      text: "考古物料出现后，网友开始重新审视这张脸。",
      points: [
        "被扒出早年在娱乐场所工作的浓妆夜场照与视频",
        "私下性格与「害羞社恐」人设差异明显",
        "多条早期动态中自称的年龄、经历与其设定不符",
      ],
    },
    timeline: [
      { time: "2023-05", title: "清纯人设出道", text: "桑晚凭一组校园风写真爆红，被贴上「初恋脸」标签迅速圈粉。" },
      { time: "2025-02", title: "异样风格物料", text: "社交平台上开始出现与其人设迥异的零星旧照，粉丝一度表示「认错人」。" },
      { time: "2026-04", title: "考古潮兴起", text: "大量早年物料被集中搬运，纯欲顶流的「另一面」被完整拼出。" },
      { time: "2026-09", title: "人设全面重估", text: "品牌与粉丝开始重新审视其「清纯」叙事的真实性，舆论两极分化。" },
    ],
    faq: [
      { q: "为什么「清纯」人设最容易引发大规模考古？", a: "因为清纯是一种高度依赖「想象与纯化」的人设，任何与设定相悖的历史影像都会带来强烈反差。越是被神化，考古的欲望就越强。" },
      { q: "网友考古的行为是否应该被认可？", a: "在不涉及隐私侵权、不编造事实的前提下，观众对公众人物过往公开内容的审视属于正常讨论。但应就事论事，避免人身攻击与断章取义。" },
      { q: "艺人该如何面对过去的公开物料？", a: "最有效的方式是坦诚。越是刻意回避或强行否认公开可见的历史，越容易放大反差；坦然面对成长与变化，反而更能赢得理解。" },
    ],
    paragraphs: [
      "在「反差吃瓜」的语料库里，桑晚大概是最能解释「什么叫同一个人，两种人生」的样本。一张脸，两种画风，中间只隔了一部考古史。",
      "她走红的那套人设几乎无可挑剔：青涩、腼腆、笑起来像春日里的光。镜头前的每一次眨眼都经过设计，每一个「害羞低头」都被反复演练，只为维持「白月光」这个高利润的标签。",
      "然而互联网是有记忆的。当早年间那些风格大胆的物料被逐条挖出，清纯的滤镜开始像剥落的墙皮一样一片片掉落。人们震惊的，不是她曾经张扬，而是她把「曾经」藏得如此彻底。",
      "真正的反差，或许在于她一边极力否认过去的自己，一边又靠着这份「清纯」叙事持续获利。当公众感受到被隐瞒与欺骗，曾经的爱慕便迅速转化为审视与戏谑。",
      "我们无意评判一个人的过去，但「反差吃瓜局」始终关注的是：当一个人选择用某个人设去换取关注与利益时，她是否愿意为这个人设的持续与真实负责。桑晚给出了一个耐人寻味的答案，也留给了所有从业者一道关于「诚实」的思考题。",
    ],
  },
  {
    id: "case-6",
    person: "富二代·顾彦哲",
    title: "「富二代」人设大型翻车：豪车全靠租，身家全靠编",
    category: "identity",
    tag: "身份揭秘",
    summary:
      "凭借「财富自由富二代」人设圈粉无数的顾彦哲，被扒出豪车为租赁、豪宅为样板间。穷人看富人表演，上演大型人间真实。",
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20editorial%20art%20of%20luxury%20sports%20car%20with%20rental%20sign%20and%20masked%20poser%20in%20warm%20cream%20amber%20and%20vermilion%20tone%2C%20fake%20wealth%20lifestyle%20theme%2C%20minimalist%20graphic%20contrast%2C%20high%20detail&width=1200&height=900&seq=fc-case-06&orientation=landscape",
    hot: 88,
    heatText: "争议性话题第一",
    views: "398万",
    comments: "2.9万",
    published: "2026-08-31",
    watch: ["#假富二代", "#租赁豪车", "#人设翻车"],
    before: {
      label: "公开人设",
      text: "顾彦哲的账号，就是一本行走的「财富展示册」。",
      points: [
        "标签：豪门贵子、留学海归、财富自由",
        "日常晒豪车豪宅、私人会所、天价账单",
        "自称「家里有几家公司，只是不想继承」",
      ],
    },
    after: {
      label: "反转实锤",
      text: "租赁记录与打卡照被逐张扒出，财富神话一夜褪色。",
      points: [
        "被扒出多张「座驾」实际来自同一家高端租赁公司",
        "所谓「自家豪宅」实为某楼盘的开放样板间",
        "自称的海归学历被查出与公开学校档案不符",
      ],
    },
    timeline: [
      { time: "2023-01", title: "富二代人设上线", text: "顾彦哲以「不想继承家业」的富二代形象开号，迅速吸引对「上流生活」好奇的粉丝。" },
      { time: "2025-09", title: "穿帮苗头", text: "有网友发现其多张照片背景中出现同一件租赁公司制服的工作人员。" },
      { time: "2026-03", title: "租赁流水曝光", text: "疑似租赁记录流出，多台豪车的「持有」与「租用」时间线高度吻合。" },
      { time: "2026-08", title: "神话破灭", text: "其账号一夜清空动态，曾经的财富人设成为全网群嘲的经典案例。" },
    ],
    faq: [
      { q: "为什么「假富豪」人设格外容易翻车？", a: "财富人设依赖大量实物佐证，而实物（车、房、游艇）都有可追溯的第三方记录。造假的成本高、破绽多，一旦被起底，谎言链条便全线崩塌。" },
      { q: "普通人为什么会相信这类人设？", a: "一方面来自对「上流生活」的好奇与向往，另一方面是「锚定效应」——只要展示得足够全面、足够逼真，人们很容易默认其为真实。" },
      { q: "如何快速识别「假富人」？", a: "看信息是否可交叉验证：公司是否真实可查、车牌是否频繁变动、豪宅背景是否与样板间重合。华丽的表象最怕的就是被「较真」。" },
    ],
    paragraphs: [
      "如果有人问，反差吃瓜局里最「人间真实」的剧本是什么，顾彦哲的故事一定榜上有名。他用自己的实际行动证明：哪怕是「富二代」，只要人设是租来的，也总有一天会漏气。",
      "他的账号堪称一部精装版「财富成功学」：豪车、豪宅、会所、天价酒水，每一条动态都在拼命暗示「我和你们不是一个世界的人」。而这种「秀优越」的剧本，恰恰精准踩中了大众的好奇心与逆反心。",
      "当一个看客好奇，就会有人去较真。很快，多张看似随意的照片里，出现了不该出现的细节：同一件制服、同一块车牌、同一间样板间的角度。租赁与「持有」之间的那层纸，被一层层捅破。",
      "最讽刺的是，为了维持谎言，他甚至不惜编造学历与家业，把「假装有钱」演绎成了一场需要持续投入的连续剧。而当真相揭穿，曾经围观羡慕的粉丝，立刻化身最熟练的段子手。",
      "顾彦哲的翻车，是一场关于「表演性消费」的大型预警：用金钱堆砌出来的优越感，终究敌不过真实。反差吃瓜局想提醒每一位观众，别让短视频里的财富神话，成为你衡量世界与现实的标准。",
    ],
  },
];

export interface ArticleItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  date: string;
  views: string;
  comments: string;
  minutes: number;
  source: string;
  tags: string[];
  paragraphs: string[];
}

export const articles: ArticleItem[] = [
  {
    id: "art-1",
    title: "深夜复盘：翻车主播们的「道歉话术」为什么总是一个模子？",
    summary: "从「对不起粉丝」到「以后会做得更好」，我们拆解了直播间翻车后的高频话术模板。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20megaphone%20and%20microphone%20with%20speech%20bubble%20apology%20in%20warm%20paper%20amber%20and%20vermilion%20tone%2C%20minimalist%20graphic%20high%20contrast%2C%20high%20detail&width=1200&height=800&seq=fc-art-01&orientation=landscape",
    category: "吃瓜方法论",
    date: "2026-09-06",
    views: "18.6万",
    comments: "892",
    minutes: 6,
    source: "编辑精选",
    tags: ["#翻车复盘", "#道歉话术", "#主播生态"],
    paragraphs: [
      "每一个翻车现场，几乎都伴随着一场精心准备的「道歉发布会」。今天我们就来扒一扒，这些道歉话术里藏着哪些惊人的相似性。",
      "最常见的第一句，永远是「向一直以来支持我的粉丝说声对不起」。这招的高明之处在于，它先占据了「爱粉丝」的道德高地，让接下来的解释显得更像「委屈」而非「辩解」。",
      "紧接着是「我压力太大了」或「我只是一时冲动」。把结构性的人设造假，巧妙地降维成个人情绪失控，试图用「人非圣贤」来博取同情。",
      "然后是关键的「避重就轻」：承认最轻微的部分，回避最致命的部分。比如承认「选品有疏忽」，却对「天价课程的割韭菜逻辑」只字不提。",
      "最后用一句「我会好好反省，未来用行动证明自己」收尾，把球重新踢给时间。因为所有人都知道，时间会冲淡记忆，而流量从不等人。",
      "扒完这些套路你会发现，真正让网友愤怒的，往往不是事件本身，而是那种「以为你在真诚道歉，结果你还在背台词」的二次欺骗。",
    ],
  },
  {
    id: "art-2",
    title: "前后对比有多假？一张图看懂「滤镜照妖镜」背后的运镜逻辑",
    summary: "为什么网图里的身材、皮肤和实物差那么多？我们拆解了美颜与滤镜的底层套路。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20art%20of%20face%20half%20airbrushed%20perfect%20half%20raw%20real%20in%20warm%20cream%20amber%20vermilion%20tone%2C%20filter%20vs%20reality%20makeup%20illusion%20theme%2C%20minimalist%20high%20contrast%2C%20high%20detail&width=1200&height=800&seq=fc-art-02&orientation=landscape",
    category: "滤镜照妖镜",
    date: "2026-09-04",
    views: "32.1万",
    comments: "1.4万",
    minutes: 5,
    source: "专栏",
    tags: ["#滤镜打假", "#美颜逻辑", "#网图真相"],
    paragraphs: [
      "「滤镜照妖镜」栏目今天不开扒具体人物，而是想带你看懂滤镜本身的「作案手法」。因为看懂了底层逻辑，你就能自动识破八成的人设照骗。",
      "第一招是「补光」。任何滤镜的第一优先级都不是瘦脸，而是通过补光让肤色均匀、轮廓柔和。这就是为什么很多生图显得「黄、暗、脏」，而精修图却「白、净、透」的原因。",
      "第二招是「比例」。拉长腿、收窄脸、放大眼，本质是修改了人体的黄金比例。当一张照片里所有比例都「完美过头」，恰恰是它最假的信号。",
      "第三招是「情境」。真正的照骗高手不会只修脸，他们会选择逆光、遮挡、角度等手法，让缺陷「物理消失」，比单纯的滤镜更难以察觉。",
      "理解这些，不是为了让你对网上的美好彻底失去信心，而是帮你建立一套「反差识别雷达」：当一个人把所有照片都修饰到完美无瑕、没有任何「不完美瞬间」时，就该多问一句——真实的那一面，到底藏在哪？",
    ],
  },
  {
    id: "art-3",
    title: "为什么「人设越是完美」翻车越快？从心理学看反差陷阱",
    summary: "完美人设是一把双刃剑。它带来高关注的同时，也埋下了必然反噬的伏笔。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20pedestal%20and%20cracked%20mask%20falling%20off%20in%20warm%20amber%20cream%20vermilion%20tone%2C%20psychology%20of%20perfect%20image%20collapse%2C%20minimalist%20graphic%20high%20contrast%2C%20high%20detail&width=1200&height=800&seq=fc-art-03&orientation=landscape",
    category: "吃瓜方法论",
    date: "2026-08-29",
    views: "25.4万",
    comments: "1.1万",
    minutes: 7,
    source: "深度",
    tags: ["#心理学", "#完美人设", "#反差效应"],
    paragraphs: [
      "在反差吃瓜局拆解的无数案例里，藏着一个惊人的共性：翻车最惨的，往往是那些把「完美」演到极致的。为什么越完美，越容易摔得重？",
      "心理学里有个概念叫「期望落差」。观众对一个人设的预期越高，现实反差带来的负面感受就越强烈。一个承认自己有缺点的人偶尔翻车，大家只会一笑而过；一个把「完人」立起来的人哪怕只犯一点错，都会被无限放大。",
      "另一个原因是「认知失调」。当观众已经投入了大量情感与信任去认同某个人设时，突然发现人设是假的，他们感受到的不只是失望，还有一种「我竟然被愚弄」的自我怀疑。这种被背叛感，会转化为成倍的愤怒。",
      "所以真正聪明的内容创作者，从不会把自己包装成没有缺点的神。他们敢于暴露真实的小瑕疵，反而建立了更强的信任壁垒。",
      "看懂了这套逻辑，你也就明白：那些越是要把自己捧上神坛的人，越是在亲手给自己的翻车倒计时。真实，永远是人设经济里最稀缺、也最保命的资产。",
    ],
  },
  {
    id: "art-4",
    title: "吃瓜指南：如何不动声色地判断一个网红人设的真假？",
    summary: "四条硬核观察法，帮你一眼看穿「演出来的完美」与「藏不住的真相」。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20magnifying%20glass%20and%20mask%20and%20truth%20icon%20in%20warm%20cream%20amber%20vermilion%20tone%2C%20truth%20detection%20theme%2C%20minimalist%20graphic%20high%20contrast%2C%20high%20detail&width=1200&height=800&seq=fc-art-04&orientation=landscape",
    category: "吃瓜方法论",
    date: "2026-08-27",
    views: "41.2万",
    comments: "2.3万",
    minutes: 8,
    source: "编辑精选",
    tags: ["#吃瓜指南", "#人设鉴别", "#方法论"],
    paragraphs: [
      "做反差吃瓜局这么久，我们总结了一套快速识别「表演型人设」的方法。今天把它整理成四条观察法，希望能帮你少走弯路。",
      "第一条：看「可验证的硬信息」是否经得起推敲。学历、履历、资产、品牌合作，这些都能通过第三方渠道交叉验证。一个真正的人设，经得起「较真」；一个包装的人设，最怕的就是「深挖」。",
      "第二条：看「人设是否过于单一且高纯度」。现实中的人都是复杂的、立体的。如果一个人的公开形象永远只有「完美」这一个侧面，没有任何真实的脆弱或矛盾，那大概率是被精心剪辑过的。",
      "第三条：看「变现方式与人设的关系」。观察一个人是靠人设本身获利，还是在人设之上叠加了高溢价的割韭菜商品。当人设开始为高价课、天价货背书时，就值得多留一个心眼。",
      "第四条：看「翻车后的反应」。真正坦诚的人会在第一时间直面核心问题；而表演型的人，永远在避重就轻、含糊其辞、把责任推给情绪与外部环境。",
      "记住这四条，你不是在「抬杠」，而是在保护自己对真实世界的判断力。毕竟，吃瓜的乐趣，从来不在于看谁塌房，而在于看清真相的过程本身。",
    ],
  },
  {
    id: "art-5",
    title: "从「白月光」到「照妖镜」，互联网记忆到底有多可怕？",
    summary: "当曾经的内容成为今日的罪证，网络考古是如何一步步摧毁完美叙事的？",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20art%20of%20time%20machine%20and%20old%20photographs%20stack%20in%20warm%20cream%20amber%20vermilion%20tone%2C%20internet%20memory%20archive%20theme%2C%20minimalist%20graphic%20contrast%2C%20high%20detail&width=1200&height=800&seq=fc-art-05&orientation=landscape",
    category: "滤镜照妖镜",
    date: "2026-08-25",
    views: "22.7万",
    comments: "986",
    minutes: 6,
    source: "专栏",
    tags: ["#互联网记忆", "#考古", "#人设崩塌"],
    paragraphs: [
      "在反差吃瓜的叙事里，没有哪个「考古」故事能脱离一样东西——互联网记忆。它像一台永不宕机的录像机，忠实记录着每个人曾经说过的话、做过的事。",
      "很多人以为，删掉动态、清空账号、改名换姓，就能抹去过去。但互联网的本质决定了：只要内容被公开过，就几乎不可能被彻底清除。截图、缓存、转发，都在为「未来可能的翻车」存档。",
      "这种记忆对普通人而言是「社死」，对靠人设吃饭的公众人物而言，则是悬在头顶的达摩克利斯之剑。你越努力塑造「当下完美的自己」，过去那个「不完美的自己」就越会成为致命的漏洞。",
      "所以与其说网友可怕，不如说是「说谎的成本变高了」。当谎言与真实的历史发生碰撞，崩塌的不仅是一个人设，更是公众对「轻信」的再一次反思。",
      "互联网记忆是一面照妖镜，但它照见的，从来不只是别人，也是每一个屏幕前选择相信或质疑的我们。",
    ],
  },
  {
    id: "art-6",
    title: "冷静吃瓜：翻车之后，网友的「正义感」是否也会被流量绑架？",
    summary: "当我们围观一场塌房时，如何在「看热闹」与「独立思考」之间保持清醒。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20crowd%20watching%20stage%20with%20spotlight%20and%20popcorn%20in%20warm%20cream%20amber%20vermilion%20tone%2C%20mob%20psychology%20watching%20theme%2C%20minimalist%20graphic%20contrast%2C%20high%20detail&width=1200&height=800&seq=fc-art-06&orientation=landscape",
    category: "吃瓜方法论",
    date: "2026-08-23",
    views: "15.9万",
    comments: "804",
    minutes: 5,
    source: "深度",
    tags: ["#理性吃瓜", "#网络审判", "#独立思考"],
    paragraphs: [
      "反差吃瓜局做了这么多期「反转深扒」，最想提醒大家的一件事其实是：吃瓜可以，但别把「围观」误当成「审判」。",
      "当一场塌房发生时，舆论场往往会迅速分成两派：一边是群情激愤的「锤死他」，一边是冷静理性的「让子弹飞」。有趣的是，反转新闻里最常打脸的，往往是冲在最前面的那一批。",
      "这是因为「情绪」天然追求最快的结果，而「真相」往往需要时间发酵。很多人并非真的关心事件本身，只是享受「站在道德高地谴责别人」的快感。这种被流量绑架的正义感，有时反而成了新的伤害。",
      "真正的「冷静吃瓜」，应该是：对看到的每一条「实锤」，先问一句「来源可靠吗、有第三方佐证吗」；对每一个翻车的人，先区分「行为的错」与「人身的攻击」。",
      "我们提供的是「反差线索」与「来龙去脉」，而结论，永远应该由你自己基于事实去判断。理性，是吃瓜这件事里最性感的品质。",
    ],
  },
];

export interface RankItem {
  rank: number;
  id: string;
  name: string;
  title: string;
  delta: string;
  score: number;
  tags: string[];
  trend: number;
}

export const hotRanks: RankItem[] = [
  { rank: 1, id: "case-5", name: "桑晚", title: "纯欲顶流早年被考古，清纯滤镜一夜碎裂", delta: "↑12位", score: 98, tags: ["纯欲", "考古"], trend: 12 },
  { rank: 2, id: "case-1", name: "暖姐·林若薇", title: "情感导师被曝天价课割韭菜，鸡汤人设崩塌", delta: "↑8位", score: 97, tags: ["情感导师", "翻车"], trend: 8 },
  { rank: 3, id: "case-4", name: "周之远", title: "环保大使被拍到坐私人飞机开豪车", delta: "持平", score: 95, tags: ["双标", "环保"], trend: 0 },
  { rank: 4, id: "case-2", name: "陈一川", title: "自律帝深夜撸串被偶遇，晨跑直播竟是循环素材", delta: "↑15位", score: 93, tags: ["自律", "滤镜"], trend: 15 },
  { rank: 5, id: "case-3", name: "苏予", title: "素人学霸学历与出身被逐条起底", delta: "↓2位", score: 91, tags: ["学霸", "身份"], trend: -2 },
  { rank: 6, id: "case-6", name: "顾彦哲", title: "假富二代豪车全靠租，豪宅实为样板间", delta: "↑5位", score: 89, tags: ["假富豪", "租赁"], trend: 5 },
];

export interface FaqItemSite {
  q: string;
  a: string;
}

export const siteFaqs: FaqItemSite[] = [
  { q: "反差吃瓜局是一个什么样的网站？", a: "反差吃瓜局是一个专注拆解「人设反转、身份揭秘、前后对比、言行双标」等内容的内容媒体。我们以冷静、客观、讲证据的方式，追踪公众人物与热点事件背后那些「表里不一」的故事。" },
  { q: "网站里的当事人和事件是真实的吗？", a: "本网站所有当事人、事件、对话均作为内容演示与传播研究用途而虚构，请勿与现实中的任何人或机构对应。我们呈现的，是「反差叙事」背后的逻辑与方法论。" },
  { q: "我如何提交一条吃瓜线索或投稿？", a: "你可以在页面底部或「关于我们」中通过投稿表单留下你的线索。请尽量附上可核实的公开信息源，我们的编辑团队会进行交叉验证后再决定是否跟进。" },
  { q: "你们的内容会针对当事人进行人身攻击吗？", a: "不会。我们的定位是「讲逻辑、讲证据」，区分「行为的对错」与「人身攻击」，反对网暴与断章取义，倡导理性吃瓜与独立思考。" },
  { q: "可以转载或引用反差吃瓜局的内容吗？", a: "欢迎在标明来源的情况下进行观点引用与简要转载。出于尊重与版权考虑，请勿在未授权的情况下对长文进行洗稿或大幅转载。" },
];

export const tagCloud = [
  "人设反转", "身份揭秘", "滤镜打假", "言行双标", "打脸实录",
  "前后对比", "网红塌房", "富二代造假", "学历争议", "道歉话术",
  "素人剧本", "流量密码", "反转现场", "考古学", "理性吃瓜",
];